/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIAgentSummary {
    getFixupPrototypeFunction() { return AIAgentSummary.fixupPrototype; }

    static newInstance(model: Partial<AIAgentSummary>): AIAgentSummary {
        let obj = Object.assign(new AIAgentSummary(), model);
        AIAgentSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIAgentSummary>): AIAgentSummary {
        if (!model) return null;
        return AIAgentSummary.newInstance(<AIAgentSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIAgentSummary) {
        if (!obj) return;

        models.AIAgentSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIAgentSummary): boolean {
        Object.setPrototypeOf(obj, AIAgentSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.traces === undefined) {
            this.traces = 0;
        }
        if (this.models) {
            for (let val of this.models) {
                models.AIAgentModelSummary.fixupPrototype(val);
            }
        }
    }

    /**
     * Agent identity resolved from spans (AgentCore runtime id or service name)
     */
    agent_id: string;

    /**
     * Agent display name derived from the span service name
     */
    agent_name: string;

    /**
     * Service account ID linked to the Agent
     */
    service_account_id: string;

    /**
     * Distinct trace count in the time range; traces span models, so this cannot be summed from the model breakdown
     */
    traces: number;

    /**
     * Per-model cost and token breakdown for this agent in the time range
     */
    models: Array<models.AIAgentModelSummary>;

}
